import { EntityType, Maybe, UserOrganizationInfoRoles } from '../../apis/graphql/types';
import { INITIAL_PERMISSIONS, USER_ROLES, USER_STATUS } from './constants';
import { PermissionByEntityType, Permissions } from './models';

export const checkUserStatus = (
  inputStatus?: Maybe<string>
): { isActive: boolean; isInvited: boolean; isUnavailable: boolean } => {
  const { active, invited, expired, deactivated } = USER_STATUS;

  return {
    isActive: inputStatus === active,
    isInvited: inputStatus === invited,
    isUnavailable: [deactivated, expired].includes(inputStatus as USER_STATUS),
  };
};

export const checkUserRole = (inputRoles?: UserOrganizationInfoRoles[]): Record<USER_ROLES, boolean> => {
  const result: Record<USER_ROLES, boolean> = {
    [USER_ROLES.accessManager]: false,
    [USER_ROLES.adAccountAdmin]: false,
    [USER_ROLES.adAccountAnalyst]: false,
    [USER_ROLES.analyst]: false,
    [USER_ROLES.buyer]: false,
    [USER_ROLES.creativeManager]: false,
    [USER_ROLES.creativeReviewer]: false,
    [USER_ROLES.draxAdmin]: false,
    [USER_ROLES.draxOpsManager]: false,
    [USER_ROLES.mcInventoryManager]: false,
    [USER_ROLES.member]: false,
    [USER_ROLES.orgAdmin]: false,
    [USER_ROLES.planner]: false,
    [USER_ROLES.pricingManager]: false,
    [USER_ROLES.seller]: false,
    [USER_ROLES.spReviewer]: false,
    [USER_ROLES.supportAdmin]: false,
    [USER_ROLES.supportEngineer]: false,
    [USER_ROLES.trafficker]: false,
  };

  inputRoles?.forEach((role) => {
    result[role.role as USER_ROLES] = true;
  });

  return result;
};

export const getEntityTypes = (inputRoles?: UserOrganizationInfoRoles[]): EntityType[] => {
  return inputRoles?.map(({ entityType }) => entityType) || [];
};

export const getPermissions = (
  permissionByEntityType: PermissionByEntityType,
  roles: Record<USER_ROLES, boolean>,
  entityTypes: EntityType[]
): Permissions => {
  const permissions = { ...INITIAL_PERMISSIONS };

  entityTypes.forEach((item) => {
    const { createRoles, readRoles, updateRoles, deleteRoles } = permissionByEntityType[item];

    permissions.create = permissions.create || createRoles.some((role) => roles[role]);
    permissions.read = permissions.read || readRoles.some((role) => roles[role]);
    permissions.update = permissions.update || updateRoles.some((role) => roles[role]);
    permissions.delete = permissions.delete || deleteRoles.some((role) => roles[role]);
  });

  return permissions;
};
